import jwt from 'jwt-simple'

const secret = 'django-insecure--_@f_$95xoqweasd123rkjf7(t$%^^#@bvc2342346so)lzldfsdfz23123@#%$lg6=_hof6';

class Util
{

	isNumber ( n ) { return /^-?[\d.]+(?:e-?\d+)?$/.test( n ); }

	convertNumber ( strNum, type )
	{
		let pn = [ "۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹" ];
		let ar = [ "٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩" ];
		let en = [ "0", "1", "2", "3", "4", "5", "6", "7", "8", "9" ];

		let cache = strNum;

		for ( let i = 0 ; i < 10 ; i++ )
		{
			if ( type === "fa" )
			{
				let regex_en = new RegExp( en[i], 'g' );

				cache = cache.replace( regex_en, pn[i] );
			}
			else
			{
				let regex_fa = new RegExp( pn[i], 'g' );
				let regex_ar = new RegExp( ar[i], 'g' );

				cache = cache.replace( regex_fa, en[i] );
				cache = cache.replace( regex_ar, en[i] );
			}

		}
		return cache;
	}

	convertNumberToPersion ( body )
	{
		if ( !body )
		{
			return;
		}

		let persian = { 0 : '۰', 1 : '۱', 2 : '۲', 3 : '۳', 4 : '۴', 5 : '۵', 6 : '۶', 7 : '۷', 8 : '۸', 9 : '۹' };

		function traverse ( el )
		{
			if ( parseInt( el.nodeType ) === 3 )
			{
				let list = el.data.match( /[0-9]/g );
				if ( list !== null && list.length !== 0 )
				{
					for ( let i = 0 ; i < list.length ; i++ )
						el.data = el.data.replace( list[i], persian[list[i]] );
				}
			}
			for ( let i = 0 ; i < el.childNodes.length ; i++ )
			{
				traverse( el.childNodes[i] );
			}
		}

		traverse( body );
	}

	decodeJwt ( token )
	{
		return jwt.decode( token, secret );
	}

	encodeJwt ( payload )
	{
		return jwt.encode( payload, secret, 'HS256' )
	}

	isAccessTokenExpired ( state )
	{
		if ( state.access && state.access.exp )
		{
			return 1000 * state.access.exp - ( new Date() ).getTime() < 5000
		}
		return true
	}


	setSession ( key, value )
	{
		localStorage.setItem( key, JSON.stringify( value ) );
	}

	getSession ( key )
	{
		const tokenString = localStorage.getItem( key );
		return tokenString && tokenString !== 'undefined' && tokenString !== undefined ? JSON.parse( tokenString ) : null
	}

	clearSession ( key )
	{
		window.localStorage.removeItem( key )
	}

	clearAll ()
	{
		window.localStorage.removeItem( "token" );
		window.localStorage.removeItem( "state" );
		window.localStorage.removeItem( "phoneNumber" );
		window.localStorage.clear();
	}

	getOperatingSystem ( window )
	{
		let operatingSystem = 'Not known';
		if ( window.navigator.appVersion.indexOf( 'Win' ) !== -1 )
		{
			operatingSystem = 'Windows OS';
		}
		if ( window.navigator.appVersion.indexOf( 'Mac' ) !== -1 )
		{
			operatingSystem = 'MacOS';
		}
		if ( window.navigator.appVersion.indexOf( 'X11' ) !== -1 )
		{
			operatingSystem = 'UNIX OS';
		}
		if ( window.navigator.appVersion.indexOf( 'Linux' ) !== -1 )
		{
			operatingSystem = 'Linux OS';
		}

		return operatingSystem;
	}

}

export default Util = new Util();
